// pastoralLanguage.js — Sanitizador de identidade pastoral episcopal.
//
// Substitui vocabulário católico-romano por vocabulário episcopal/evangélico
// e remove fórmulas mecânicas que não refletem a teologia bíblica de oração.
//
// Uso: sanitizePastoralLanguage(text) → texto ajustado (idempotente).
//
// Regras:
//   "reze"           → "ore"
//   "rezar"          → "orar"
//   "rezando"        → "orando"
//   "reze X vezes"   → "permaneça em oração"  (remove repetição mecânica)
//   "diga X vezes"   → "permaneça em oração"
//   "repita X vezes" → "permaneça em oração"
//
// Regras preservam capitalização e acento simples. NÃO altera textos
// bíblicos entre aspas curvas (“…”) — só a linguagem pastoral externa.

const REPEAT_PATTERNS = [
  /\b(reze|diga|repita)\s+(uma|duas|tr[êe]s|quatro|cinco|seis|sete|\d+)\s+vezes\b/gi,
  /\b(reze|diga|repita)\s+(uma|duas|tr[êe]s|quatro|cinco|seis|sete|\d+)\s+x\b/gi,
];

const SUBSTITUTIONS = [
  [/\brezei\b/gi, "orai"],
  [/\brezemos\b/gi, "oremos"],
  [/\brezavam\b/gi, "oravam"],
  [/\brezou\b/gi, "orou"],
  [/\brezaram\b/gi, "oraram"],
  [/\brezam\b/gi, "oram"],
  [/\brezando\b/gi, "orando"],
  [/\brezaste\b/gi, "oraste"],
  [/\brezar\b/gi, "orar"],
  [/\breze\b/gi, "ore"],
  [/\brezas\b/gi, "orações"],
];

function preserveCase(from, to) {
  if (from[0] === from[0].toUpperCase()) {
    return to[0].toUpperCase() + to.slice(1);
  }
  return to;
}

/**
 * Aplica sanitização pastoral ao texto. Idempotente.
 * @param {string} text
 * @returns {string}
 */
export function sanitizePastoralLanguage(text) {
  if (!text || typeof text !== "string") return text || "";
  let out = text;
  // 1) Remove fórmulas mecânicas de repetição.
  for (const pat of REPEAT_PATTERNS) {
    out = out.replace(pat, () => "permaneça em oração");
  }
  // 2) Substituições de vocabulário mantendo capitalização.
  for (const [pat, replacement] of SUBSTITUTIONS) {
    out = out.replace(pat, (match) => preserveCase(match, replacement));
  }
  return out;
}
